import { connect } from 'react-redux';
import MainPage from './MainPage';
import { triggerLoginOnlyBySsoView } from '../../actions/app';
import { unsetManagementOptionWithSinglePath } from '../../actions/booking';

const mapStateToProps = state => ({
  rootLoaded: state.booking.rootLoaded,
  pathLoaded: state.booking.pathLoaded,
  managementSelected: state.booking.managementSelected,
  userIdentified: state.session.userIdentified,
  doneIdentifying: state.session.doneIdentifying,
  loginOnlyBySso: state.organization.loginOnlyBySso,
  shouldSelectEmployer: state.booking.shouldSelectEmployer,
  showLoginOnlyBySsoView: state.app.showLoginOnlyBySsoView,
  hasEmployer: state.session.hasEmployer,
  requireContinueConfirmation: state.session.requireContinueConfirmation,
  loginFailedNotAllowedByEmployer: state.session.loginFailedNotAllowedByEmployer,
  loginFailedNotDueToMultipleEmployers: state.session.loginFailedNotDueToMultipleEmployers,
  userConfirmedContinue: state.session.userConfirmedContinue,
  showCancelReservationScreen: state.cancelling.showCancelReservationScreen,
  roots: state.booking.roots,
  loginFirst: state.booking.loginFirst,
  uniquePath: state.booking.uniquePath,
  user: state.session.user,
  selectedDepartment: state.session.selectedDepartment,
  selectionHandler: state.booking.selectionHandler,
  messageLocalizationKey: state.session.messageLocalizationKey,
  triggerInitialScroll: state.session.triggerInitialScroll,
  viaSso: state.session.viaSso,
  fetchPathAfterLogin: state.booking.fetchPathAfterLogin,
  historyInitialLoading: state.history.historyInitialLoading,
  historyInitialLoaded: state.history.historyInitialLoaded,
  selectedEmployer: state.session.selectedEmployer,
  requiresEmployer: state.session.requiresEmployer,
  configurationLoaded: state.app.configurationLoaded
});
const mapDispatchToProps = dispatch => ({
  triggerLoginOnlyBySsoView: dispatch(triggerLoginOnlyBySsoView),
  unsetManagementOptionWithSinglePath: dispatch(unsetManagementOptionWithSinglePath)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPage);



// WEBPACK FOOTER //
// ./src/components/MainPage/index.js